/* eslint-disable camelcase */
import React from 'react';

import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Hidden } from '@material-ui/core';

import { Text, HiddenMobile } from '@components';
import { useForm, useUser } from '@hooks';
import Breadcrumbs from '@navigation/Breadcrumbs';
import { Input, FormBackground, FormContainer, ButtonsContainer, Button } from '@components/Forms';
import { parsePhoneObject } from '@helpers';
import { regionPhoneCode } from '@constants/regions';

const Phone = styled.div`
  display: flex;
  flex-direction: row;
`;

const CountryCode = styled(Input)`
  width: 62px;
`;

const PhoneNumber = styled(Input)`
  flex-grow: 1;
  margin-left: 8px;
`;

const UserPhoneNumberEdit = ({ route }) => {
  const {
    updatePhone,
    selected: { phone },
  } = useUser({ fetchUsers: false });
  const { t } = useTranslation();
  const history = useHistory();
  const { number, region_id } = phone[phone.length - 1];
  const { formValues, handleInputChange, isValid, errors, isInitial } = useForm({
    phone_number: region_id + number,
  });

  const handleSubmit = () => {
    if (!isValid()) return '';
    updatePhone(parsePhoneObject(formValues.phone_number));
  };

  return (
    <>
      <Hidden mdDown>
        <Breadcrumbs route={route} />
      </Hidden>
      <FormBackground>
        <FormContainer>
          <HiddenMobile>
            <Text type="H6-w400" color="gray800">
              {t('editPhoneNumber.subtitle')}
            </Text>
          </HiddenMobile>
          <Phone>
            <CountryCode
              id="country_code"
              testId="country_code-testId"
              value={`+${regionPhoneCode}`}
              disabled
            />
            <PhoneNumber
              id="phone_number"
              testId="phone_number-testId"
              label={t('editPhoneNumber.phone_number')}
              value={formValues.phone_number}
              onChange={handleInputChange}
              error={!!errors.phone_number}
              caption={errors.phone_number}
            />
          </Phone>
          <ButtonsContainer>
            <HiddenMobile>
              <Button
                type="outlined"
                id="btn-cancel"
                testId="btn-cancel-testId"
                onClick={() => history.goBack()}
              >
                {t('common.buttonCancel')}
              </Button>
            </HiddenMobile>
            <Button
              id="btn-submit"
              testId="btn-submit-testId"
              onClick={handleSubmit}
              disabled={isInitial()}
            >
              {t('editPhoneNumber.submitbutton')}
            </Button>
          </ButtonsContainer>
        </FormContainer>
      </FormBackground>
    </>
  );
};

export default UserPhoneNumberEdit;
